import { render, staticRenderFns } from "./CreateIntershipActivityFromList.vue?vue&type=template&id=36c5e0b1&"
import script from "./CreateIntershipActivityFromList.vue?vue&type=script&lang=js&"
export * from "./CreateIntershipActivityFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports